import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after a short delay for better UX
      setTimeout(() => {
        setShowBanner(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    // Here you can enable analytics, tracking, etc.
    console.log('Cookies accepted - Analytics enabled');
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
    // Only essential cookies will be used
    console.log('Cookies declined - Only essential cookies');
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Cookie Banner */}
      <div className="fixed bottom-0 left-0 right-0 z-[9999] p-4 animate-slide-up">
        <div className="max-w-[1200px] mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl border-2 border-gray-200 p-6 md:p-8">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
              {/* Icon */}
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-2xl flex items-center justify-center shadow-lg">
                  <i className="fas fa-cookie-bite text-white text-3xl"></i>
                </div>
              </div>

              {/* Content */}
              <div className="flex-1">
                <h3 className="text-2xl font-black text-text mb-2">
                  🍪 نستخدمو ملفات التتبع باش نحسنو تجربتك
                </h3>
                <p className="text-text2 leading-relaxed">
                  نستعملو ملفات التتبع (Cookies) باش نحفظو حسابك، نتبعو تقدمك في الدورات، ونحسنو المنصة. 
                  الملفات الأساسية ضرورية باش المنصة تخدم مليح. 
                  <Link to="/privacy" className="text-primary hover:text-primary-dark font-bold underline mx-1">
                    شوف سياسة الخصوصية
                  </Link>
                  باش تعرف المزيد.
                </p>
              </div>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                <button
                  onClick={handleDecline}
                  className="px-6 py-3 bg-gray-100 hover:bg-gray-200 text-text font-bold rounded-xl transition-all duration-300 hover:scale-105"
                >
                  الأساسية فقط
                </button>
                <button
                  onClick={handleAccept}
                  className="px-8 py-3 bg-gradient-to-r from-primary to-primary-dark hover:from-primary-dark hover:to-primary text-white font-bold rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
                >
                  قبول الكل
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Animations */}
      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slide-up {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .animate-fade-in {
          animation: fade-in 0.3s ease-out;
        }

        .animate-slide-up {
          animation: slide-up 0.4s ease-out;
        }
      `}</style>
    </>
  );
};

export default CookieConsent;
